module.exports = __webpack_public_path__ + "img/pls备料.ccaa77e8.svg";